const moduleNameKey = "cleanupViewAdminPanel";

export const cleanupViewAdminPanelEn = {
  [moduleNameKey]: {
    title: "Cleanup",
    description:
      "Select gateways and delete them from the namespace. This removes their clients, data sources, connection results and announcements.",
    gatewayName: "Gateway",
    gatewayId: "Gateway ID",
    noGatewaysFound: "No gateways found",
    deleteButton: "Delete",
    deleting: "Deleting...",
    confirmTitle: "Delete gateways",
    confirmDescription:
      "You are about to permanently delete the following gateways:",
    confirmButton: "Delete",
    cancelButton: "Cancel",
    resultsTitle: "Cleanup results",
    resultSuccess: "Gateway deleted",
    deletedClients: "Deleted clients",
    deletedDataSources: "Deleted data sources",
    deletedConnectionResults: "Deleted connection results",
    namespace: "Namespace",
    gatewayFound: "Gateway found",
    announcementDeleted: "Announcement deleted",
    yes: "Yes",
    no: "No",
    serviceUserDeleted: "Service user deleted",
    serviceUserDeletionFailed: "Service user deletion failed",
    serviceUserNotAttempted: "Service user not attempted",
    resultFailed: "Cleanup failed",
    failedToFetchGateways: "Failed to fetch gateways",
  },
};

export const cleanupViewAdminPanelPtBr = {
  [moduleNameKey]: {
    title: "Limpeza",
    description:
      "Selecione gateways e exclua-os do namespace. Isso remove os clientes, fontes de dados, resultados de conexão e anúncios deles.",
    gatewayName: "Gateway",
    gatewayId: "ID do gateway",
    noGatewaysFound: "Nenhum gateway encontrado",
    deleteButton: "Excluir",
    deleting: "Excluindo...",
    confirmTitle: "Excluir gateways",
    confirmDescription:
      "Você está prestes a excluir permanentemente os seguintes gateways:",
    confirmButton: "Excluir",
    cancelButton: "Cancelar",
    resultsTitle: "Resultados da limpeza",
    resultSuccess: "Gateway excluído",
    deletedClients: "Clientes excluídos",
    deletedDataSources: "Fontes de dados excluídas",
    deletedConnectionResults: "Resultados de conexão excluídos",
    namespace: "Namespace",
    gatewayFound: "Gateway encontrado",
    announcementDeleted: "Anúncio excluído",
    yes: "Sim",
    no: "Não",
    serviceUserDeleted: "Usuário de serviço excluído",
    serviceUserDeletionFailed: "Falha ao excluir usuário de serviço",
    serviceUserNotAttempted: "Usuário de serviço não tentado",
    resultFailed: "Falha na limpeza",
    failedToFetchGateways: "Falha ao buscar gateways",
  },
};

export const cleanupViewAdminPanelDe = {
  [moduleNameKey]: {
    title: "Bereinigung",
    description:
      "Wählen Sie Gateways aus und löschen Sie sie aus dem Namespace. Dadurch werden deren Clients, Datenquellen, Verbindungsergebnisse und Ankündigungen entfernt.",
    gatewayName: "Gateway",
    gatewayId: "Gateway-ID",
    noGatewaysFound: "Keine Gateways gefunden",
    deleteButton: "Löschen",
    deleting: "Wird gelöscht...",
    confirmTitle: "Gateways löschen",
    confirmDescription:
      "Sie sind im Begriff, die folgenden Gateways endgültig zu löschen:",
    confirmButton: "Löschen",
    cancelButton: "Abbrechen",
    resultsTitle: "Bereinigungsergebnisse",
    resultSuccess: "Gateway gelöscht",
    deletedClients: "Gelöschte Clients",
    deletedDataSources: "Gelöschte Datenquellen",
    deletedConnectionResults: "Gelöschte Verbindungsergebnisse",
    namespace: "Namespace",
    gatewayFound: "Gateway gefunden",
    announcementDeleted: "Ankündigung gelöscht",
    yes: "Ja",
    no: "Nein",
    serviceUserDeleted: "Servicebenutzer gelöscht",
    serviceUserDeletionFailed: "Löschen des Servicebenutzers fehlgeschlagen",
    serviceUserNotAttempted: "Servicebenutzer nicht versucht",
    resultFailed: "Bereinigung fehlgeschlagen",
    failedToFetchGateways: "Gateways konnten nicht abgerufen werden.",
  },
};

export const cleanupViewAdminPanelZhHans = {
  [moduleNameKey]: {
    title: "清理",
    description:
      "选择网关并将其从命名空间中删除。这将删除它们的客户端、数据源、连接结果和公告。",
    gatewayName: "网关",
    gatewayId: "网关 ID",
    noGatewaysFound: "未找到网关",
    deleteButton: "删除",
    deleting: "正在删除...",
    confirmTitle: "删除网关",
    confirmDescription: "您即将永久删除以下网关：",
    confirmButton: "删除",
    cancelButton: "取消",
    resultsTitle: "清理结果",
    resultSuccess: "网关已删除",
    deletedClients: "已删除的客户端",
    deletedDataSources: "已删除的数据源",
    deletedConnectionResults: "已删除的连接结果",
    namespace: "命名空间",
    gatewayFound: "找到网关",
    announcementDeleted: "公告已删除",
    yes: "是",
    no: "否",
    serviceUserDeleted: "服务用户已删除",
    serviceUserDeletionFailed: "服务用户删除失败",
    serviceUserNotAttempted: "未尝试删除服务用户",
    resultFailed: "清理失败",
    failedToFetchGateways: "获取网关失败",
  },
};

export const cleanupViewAdminPanelIt = {
  [moduleNameKey]: {
    title: "Pulizia",
    description:
      "Seleziona i gateway ed eliminali dal namespace. Questa operazione rimuove i relativi client, origini dati, risultati di connessione e annunci.",
    gatewayName: "Gateway",
    gatewayId: "ID gateway",
    noGatewaysFound: "Nessun gateway trovato",
    deleteButton: "Elimina",
    deleting: "Eliminazione...",
    confirmTitle: "Elimina gateway",
    confirmDescription:
      "Stai per eliminare definitivamente i seguenti gateway:",
    confirmButton: "Elimina",
    cancelButton: "Annulla",
    resultsTitle: "Risultati della pulizia",
    resultSuccess: "Gateway eliminato",
    deletedClients: "Client eliminati",
    deletedDataSources: "Origini dati eliminate",
    deletedConnectionResults: "Risultati di connessione eliminati",
    namespace: "Namespace",
    gatewayFound: "Gateway trovato",
    announcementDeleted: "Annuncio eliminato",
    yes: "Sì",
    no: "No",
    serviceUserDeleted: "Utente del servizio eliminato",
    serviceUserDeletionFailed:
      "Eliminazione dell'utente del servizio non riuscita",
    serviceUserNotAttempted: "Utente del servizio non tentato",
    resultFailed: "Pulizia non riuscita",
    failedToFetchGateways: "Impossibile recuperare i gateway",
  },
};

export const cleanupViewAdminPanelEs = {
  [moduleNameKey]: {
    title: "Limpieza",
    description:
      "Selecciona gateways y elimínalos del namespace. Esto elimina sus clientes, fuentes de datos, resultados de conexión y anuncios.",
    gatewayName: "Gateway",
    gatewayId: "ID de gateway",
    noGatewaysFound: "No se encontraron gateways",
    deleteButton: "Eliminar",
    deleting: "Eliminando...",
    confirmTitle: "Eliminar gateways",
    confirmDescription:
      "Estás a punto de eliminar permanentemente los siguientes gateways:",
    confirmButton: "Eliminar",
    cancelButton: "Cancelar",
    resultsTitle: "Resultados de la limpieza",
    resultSuccess: "Gateway eliminado",
    deletedClients: "Clientes eliminados",
    deletedDataSources: "Fuentes de datos eliminadas",
    deletedConnectionResults: "Resultados de conexión eliminados",
    namespace: "Namespace",
    gatewayFound: "Gateway encontrado",
    announcementDeleted: "Anuncio eliminado",
    yes: "Sí",
    no: "No",
    serviceUserDeleted: "Usuario de servicio eliminado",
    serviceUserDeletionFailed: "Error al eliminar el usuario de servicio",
    serviceUserNotAttempted: "Usuario de servicio no intentado",
    resultFailed: "Error en la limpieza",
    failedToFetchGateways: "Error al obtener los gateways",
  },
};

export const cleanupViewAdminPanelNl = {
  [moduleNameKey]: {
    title: "Opschonen",
    description:
      "Selecteer gateways en verwijder ze uit de namespace. Dit verwijdert hun clients, databronnen, verbindingsresultaten en aankondigingen.",
    gatewayName: "Gateway",
    gatewayId: "Gateway-ID",
    noGatewaysFound: "Geen gateways gevonden",
    deleteButton: "Verwijderen",
    deleting: "Verwijderen...",
    confirmTitle: "Gateways verwijderen",
    confirmDescription:
      "U staat op het punt de volgende gateways definitief te verwijderen:",
    confirmButton: "Verwijderen",
    cancelButton: "Annuleren",
    resultsTitle: "Opschoonresultaten",
    resultSuccess: "Gateway verwijderd",
    deletedClients: "Verwijderde clients",
    deletedDataSources: "Verwijderde databronnen",
    deletedConnectionResults: "Verwijderde verbindingsresultaten",
    namespace: "Namespace",
    gatewayFound: "Gateway gevonden",
    announcementDeleted: "Aankondiging verwijderd",
    yes: "Ja",
    no: "Nee",
    serviceUserDeleted: "Servicegebruiker verwijderd",
    serviceUserDeletionFailed: "Verwijderen van servicegebruiker mislukt",
    serviceUserNotAttempted: "Servicegebruiker niet geprobeerd",
    resultFailed: "Opschonen mislukt",
    failedToFetchGateways: "Kan gateways niet ophalen",
  },
};

export const cleanupViewAdminPanelTr = {
  [moduleNameKey]: {
    title: "Temizlik",
    description:
      "Ağ geçitlerini seçin ve ad alanından silin. Bu işlem istemcilerini, veri kaynaklarını, bağlantı sonuçlarını ve duyurularını kaldırır.",
    gatewayName: "Ağ geçidi",
    gatewayId: "Ağ geçidi kimliği",
    noGatewaysFound: "Ağ geçidi bulunamadı",
    deleteButton: "Sil",
    deleting: "Siliniyor...",
    confirmTitle: "Ağ geçitlerini sil",
    confirmDescription:
      "Aşağıdaki ağ geçitlerini kalıcı olarak silmek üzeresiniz:",
    confirmButton: "Sil",
    cancelButton: "İptal",
    resultsTitle: "Temizlik sonuçları",
    resultSuccess: "Ağ geçidi silindi",
    deletedClients: "Silinen istemciler",
    deletedDataSources: "Silinen veri kaynakları",
    deletedConnectionResults: "Silinen bağlantı sonuçları",
    namespace: "Ad alanı",
    gatewayFound: "Ağ geçidi bulundu",
    announcementDeleted: "Duyuru silindi",
    yes: "Evet",
    no: "Hayır",
    serviceUserDeleted: "Hizmet kullanıcısı silindi",
    serviceUserDeletionFailed: "Hizmet kullanıcısı silme başarısız",
    serviceUserNotAttempted: "Hizmet kullanıcısı denenmedi",
    resultFailed: "Temizlik başarısız",
    failedToFetchGateways: "Ağ geçitleri alınamadı",
  },
};
